/**
 * Query keys for Attraction API hooks.
 *
 * Centralized query keys enable consistent cache invalidation across all attraction hooks.
 */

export const attractionQueryKeys = {
  all: ['experiences', 'attractions'] as const,
  lists: () => [...attractionQueryKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) => [...attractionQueryKeys.lists(), filters] as const,
  cities: () => [...attractionQueryKeys.all, 'cities'] as const,
  details: () => [...attractionQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...attractionQueryKeys.details(), id] as const,
  offers: (id: string) => [...attractionQueryKeys.detail(id), 'offers'] as const,
  images: (id: string) => [...attractionQueryKeys.detail(id), 'images'] as const,
};
